import React from 'react';
import { FREE_SERVICES_PATH, SERVICES_PATH } from '../util/consts';
import { Redirect } from 'react-router-dom';

const servicesConfig = {
    settings: {
        style: 'layout1',
        layout: {
            config: {
                needUserInfo: true,
                redirectOn401: true,
                footer: {
                    display: true
                }
            }
        }
    },
	routes: [
		{
            path: SERVICES_PATH,
            component: React.lazy(() => import('./services-catalog'))
        },
        {
            path: FREE_SERVICES_PATH,
            component: () => <Redirect to={SERVICES_PATH} />
        }
	]
};

export {servicesConfig};